<template>
  <v-container fluid class="pa-0">
    <PageHeader :title="title" />

    <v-card tile>
      <DataSetFileActions @error="handleMetadataUpdateError($event)" :file="file" :formFile="formFile" :editForm="editForm" @reload="fetchFileById()" @update:edit="editForm = $event" @cancel:edit="onFormCancel()" />
      <v-divider />
      <v-card-text class="card-bg-2">
        <PageLoader class="my-5" v-if="isLoading" resource-name="file details" />
        <DataSetFileMetadataValidationResponse v-if="metadataUpdateError" class="mb-3" label="File update is unsuccessful due to invalid metadata" sublabel="Please review the error messages for more information. To discard modifications, please click Cancel." :messages="metadataUpdateErrorMessages" color="red lighten-1" />
        <DataSetFileMetadataValidationResponse v-if="file && file.ValidationStatus=='Invalid'" class="mb-3" label="File Metadata is invalid" sublabel="Please review the error messages and modify the metadata fields accordingly." :messages="file.ValidationMessages" />

        <v-card class="max-width mb-3">
          <Subheader dense title="File Information" />
          <v-card-text>
            <v-list dense class="max-width">
              <v-list-tile>
                <v-list-tile-content>
                  <v-layout row wrap fill-height align-self-center class="tile-layout">
                    <v-flex xs4 md4 class="body-1 font-weight-medium">File Name</v-flex>
                    <v-flex xs4 md6 class="body-1">{{ formFile.Name }}</v-flex>
                  </v-layout>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-layout row wrap fill-height align-self-center class="tile-layout">
                    <v-flex xs4 md4 class="body-1 font-weight-medium">File Id</v-flex>
                    <v-flex xs8 md8 class="body-1">{{ formFile.Id }}</v-flex>
                  </v-layout>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-layout row wrap fill-height align-self-center class="tile-layout">
                    <v-flex xs4 md4 class="body-1 font-weight-medium">File Size</v-flex>
                    <v-flex xs8 md8 class="body-1">{{ formFile.Size }} Bytes</v-flex>
                  </v-layout>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-layout row wrap fill-height align-self-center class="tile-layout">
                    <v-flex xs4 md4 class="body-1 font-weight-medium">Date Created</v-flex>
                    <v-flex xs8 md8 class="body-1">
                      {{ formatDate(formFile.DateCreated, prettyDateTimeFormat, { isUtc: true }) }}
                    </v-flex>
                  </v-layout>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="formFile.DeleteDateTime != null">
                <v-list-tile-content>
                  <v-layout row wrap fill-height align-self-center class="tile-layout">
                    <v-flex xs4 md4 class="body-1 font-weight-medium">Date Deleted</v-flex>
                    <v-flex xs8 md8 class="body-1">
                      {{ formatDate(formFile.DeletedDateTime, prettyDateTimeFormat, { isUtc: true }) }}
                    </v-flex>
                  </v-layout>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
        <DataSetFileMetadataForm v-if="isValid" :edit="editForm" :schema-id="formFile.SchemaId" :metadata-fields="formFile.Metadata" @input-field="onMetadataFormInput($event)" @input-schema="onMetadataSchemaInput($event)" />
      </v-card-text>
    </v-card>


    
  </v-container>
</template>
<script>
  import PageHeader from '@/components/generic/PageHeader'
  import Subheader from '@/components/generic/Subheader'
  
  import {
    formatDate,
    prettyDateTimeFormat,
  } from '@/components/mixins/MomentUtil'


  import DataSetFileMetadataForm from './DataSetFileMetadataForm'
  import DataSetFileMetadataValidationResponse from './DataSetFileMetadataValidationResponse'
  import DataSetFileActions from './DataSetFileActions'



  import {
    createNamespacedHelpers,
  } from 'vuex'
  const app = createNamespacedHelpers('app')
  const ingestions = createNamespacedHelpers('ingestions')
  const authenticate = createNamespacedHelpers('authenticate')
  const rawdatarepository = createNamespacedHelpers('rawdatarepository')

  export default {
    name: 'dataset-file',
    components: {
      PageHeader,
      Subheader,
      DataSetFileMetadataForm,
      DataSetFileMetadataValidationResponse,
      DataSetFileActions,
    },    
    props: {
      id: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        prettyDateTimeFormat,
        editForm: false,
        file: null,
        formFile: {
          SchemaId: 0,
          Metadata: [],
        },
        isLoading: false,
        metadataSchemaId: -1,
        metadataUpdateError: false,
        metadataUpdateErrorMessages: [],
        isValidFormMetadataFields: false,
        isDownloading: false,
        currentImport: {},
      }
    },
    computed: {
      ...authenticate.mapGetters(['isTenantAdmin']),
      isValid() {
        return this.file != null && this.formFile.Id != null
      },
      title() {
        return (!this.isLoading && this.file != null && this.formFile.Id != null) ? this.formFile.Name : ''
      },
    },
    watch: {
      fileNameSearchString() {
        this.fileNameInput = this.fileNameSearchString
      },
    },
    async mounted() {
      await this.fetchFileById()
      if(this.file != null && this.file.Metadata != null) {
        var executionId = this.file.Metadata.find(x => x.Field == 'ExecutionId').FieldValue
        let result = await this.fetchIngestionResults({
          searchText: executionId,
        })

        if(!result.IsError) {          
          let importIndexId = result.ImportIds[0]
          this.file.RelatedFileVersions = result.ImportsIndex[importIndexId].relatedFileVersions
        }

      }
    },
    methods: {
      formatDate,
      ...app.mapActions(['setSnackbar']),
      ...rawdatarepository.mapActions(['getFileById', 'putFile']),
      ...ingestions.mapActions(['fetchIngestionResults']),
      onFormDone() {
        this.editForm = false
        this.metadataUpdateError = false
        this.handlePutFile()
      },
      onFormCancel() {
        this.editForm = false
        this.setFormFile()
      },
      async fetchFileById() {
        this.isLoading = true
        let that = this
        let options = {
          fileId: this.id,
          successCb: data => {
            that.file = data
            that.isLoading = false
            that.setFormFile()
          },
          failedCb: msg => {
            console.error(msg)
            that.isLoading = false
            that.setSnackbar({
              color: 'error',
              text: `Failed to fetch file Id:${
              that.id
              } Msg: ${msg}`,
            })
          },
        }
        return this.getFileById(options)
      },
      checkIfFileExists() {
        if (!this.isLoading && !this.isValid) {
          this.$router.push('/datasets/browse')
        }
      },
      // handleDownloadAction(id, filename) {
      //   let that = this
      //   that.isDownloading = true
      //   that.setSnackbar({
      //     text: 'Please wait while we prepare your download...',
      //     color: 'success',
      //     timeout: 0,
      //   })
      //   let options = {
      //     successful: () => {
      //       that.isDownloading = false      
      //     },
      //     failedCb: () => {
      //       that.isDownloading = false
      //       that.setSnackbar({
      //         color: 'error',
      //         text: `File ${filename} download failed`,
      //       })
      //     },
      //   }
      //   this.download(
      //     `api/RawDataRepository/file/${id}/download`,
      //     filename,
      //     options
      //   )
      // },
      onMetadataFormInput(updatedMetadata) {
        this.formFile.Metadata = updatedMetadata
      },
      onMetadataSchemaInput(schemaId) {
        //this.metadataSchemaId = schemaId
        this.formFile.SchemaId = schemaId
      },
      isValidForm(isValid) {
        this.isValidFormMetadataFields = isValid
      },
      handlePutFile() {
        let options = {
          fileId: this.file.Id,
          payload: this.formFile,
          successCb: () => {
            this.fetchFileById()
            this.setSnackbar({
              color: 'success',
              text: `File ${this.file.Name} updated successfully`,
            })
          },
          failedCb: (msg, err) => {
            console.error(msg)
            if (err.response.status == 400) {
              this.handleMetadataUpdateError(err.response.data)
            } else {
              this.setSnackbar({
                color: 'error',
                text: 'Error occurred updating file: ' + msg,
              })
            }
          },
        }
        this.putFile(options)
      },
      handleMetadataUpdateError(messages) {
        this.metadataUpdateErrorMessages = messages
        this.editForm = true
        this.metadataUpdateError = true
      },
      clearForm() {},
      setFormFile() {
        this.formFile = JSON.parse(JSON.stringify(this.file))
      },
    },
  }
</script>
<style lang="stylus" scoped>
  div.tile-layout {
    width: 100%;
  }

  div.tile-layout>>>div.body-1 {
    justify-content: center;
    display: flex;
    flex-direction: column;
  }

  div.tile-layout>>>button {
    float: right;
  }

  button.transparent-btn {
    background-color: transparent;
  }
</style>
